export default "__VITE_ASSET__e9Z46l6Q__"